<template>
    <div>
        <b-row>

            <b-col lg="6">
                <b-form-group label="الأمتحان قصير">
                    <validation-provider name="short_exam" vid="short_exam" rules="required" v-slot="{ errors }">
                        <v-select v-model="newItem.code" :options="activitiesCodes ? activitiesCodes : []" class="w-100"
                            label="label" value-field="value" :state="errors.length > 0 ? false : null" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </b-col>
            <b-col lg="6">
                <b-form-group label="اسم الأمتحان القصير">
                    <validation-provider name="short_exam_name" vid="short_exam_name" rules="required"
                        v-slot="{ errors }">
                        <b-form-input v-model="newItem.short_exam_name" type="string"
                            :state="errors.length > 0 ? false : null" placeholder="اسم الأمتحان القصير" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="6">
                <b-form-group label="الثمرة التعليمية المستهدفة">
                    <validation-provider name="education_level" vid="education_level" rules="required"
                        v-slot="{ errors }">
                        <b-form-select v-model="newItem.education_level" :state="errors.length > 0 ? false : null"
                            :options="education_levels" />

                    </validation-provider>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="6">
                <b-form-group label="يمكن الوصول له من">
                    <validation-provider name="from" vid="from" rules="required" v-slot="{ errors }">
                        <b-form-input v-model="newItem.from" type="datetime-local" :state="errors.length > 0 ? false : null"
                            placeholder="يمكن الوصل له من" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </b-col>
            <b-col lg="6">
                <b-form-group label="يمكن الوصل له حتى">
                    <validation-provider name="to" vid="to" rules="required" v-slot="{ errors }">
                        <b-form-input v-model="newItem.to" type="datetime-local" :state="errors.length > 0 ? false : null"

                            placeholder="يمكن الوصل له حتى" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row class="mb-1">
             <b-col lg="6">
                <b-form-checkbox-group v-model="newItem.allow">
                    <b-form-checkbox checked>تمكين المهلة الزمنية</b-form-checkbox>
                </b-form-checkbox-group>
            </b-col>

        </b-row>
        <b-row v-if="newItem.allow">
            <b-col lg="6">
                <b-form-group label="المهلة الزمنية">
                    <validation-provider name="period" vid="period" rules="required" v-slot="{ errors }">
                        <b-form-input v-model="newItem.period" type="number" :state="errors.length > 0 ? false : null"
                            placeholder=" المهلة الزمنية " />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </b-col>
            <b-col lg="6">
                <b-form-group label="نوع المهلة">
                    <validation-provider name="period_type" vid="period_type" rules="required" v-slot="{ errors }">
                        <b-form-select v-model="newItem.period_type" :state="errors.length > 0 ? false : null"
                            :options="period_types" />

                    </validation-provider>
                </b-form-group>
            </b-col>
        </b-row>
        <hr />

        <b-row>
            <b-col lg="6">
                <b-form-group label="نوع التقييم">
                    <validation-provider name="rate_type" vid="rate_type" rules="required" v-slot="{ errors }">
                        <b-form-select v-model="newItem.rate_type" :state="errors.length > 0 ? false : null"
                            :options="rate_types" />

                    </validation-provider>
                </b-form-group>
            </b-col>
            <b-col lg="6">
                <b-form-group label="عدد المحاولات">
                    <validation-provider name="attemps" vid="attemps" rules="required" v-slot="{ errors }">
                        <b-form-input v-model="newItem.attemps" type="number" :state="errors.length > 0 ? false : null"
                            placeholder=" عدد المحاولات " />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </b-col>
        </b-row>
        <hr>
        <b-row>
            <b-col lg="12">
                <h4>الأسئلة</h4>
            </b-col>
        </b-row>
        <QuestionsForm :questions="newItem.questions" />


    </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import QuestionsForm from "./questionsForm.vue";
import vSelect from "vue-select";
export default {
    props: ['newItem', 'activitiesCodes'],
    components: {
        ValidationProvider,
        ValidationObserver,
        vSelect,
        QuestionsForm
    },
    watch: {
    'newItem.allow'(newValue) {
      if (!newValue) {
        this.newItem.period = null;
        this.newItem.period_type = null
      }
    },
  },
    data() {
        return {
            education_levels: [],
            homework_types: [],
            file_sizes: [],
            max_files_count: [],
            rate_types: [],
            period_types: []
        }
    },
    created() {
        // Education Levels
        let e = ["CLO1", "CLO2", "CLO3"];
        this.education_levels = e.map((val) => {
            return val;
        });
        // Rate Types
        let x = ['الحد الأقصي للتقييمات', 'متوسط التقييمات']
        this.rate_types = x.map((val) => {
            return val;
        });
        //period_types
        let f = ['أيام', 'ساعات', 'دقائق', 'ثواني']
        this.period_types = f.map((val) => {
            return val;
        });
    }
}

</script>